module.exports = __webpack_public_path__ + "static/media/proximamente.fc5ef5bc.png";